import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { VocabularyItemList } from './vocab.model';
// import { VocabularyItemList } from 'com.trumbull.phx.vocabulary.api-client';
import { VocabularyService } from 'com.trumbull.phx.vocabulary.api-client';

@Injectable({ providedIn: 'root' })
export class VocabApiService {
	private readonly vocabUrl = '/api/vocab/v1';

	constructor(private readonly http: HttpClient, private readonly vocabularyService: VocabularyService) {}

	getVocabData(payload: string[], provider = 'standard'): Observable<VocabularyItemList[]> {
		const url = `${this.vocabUrl}/${provider}/${payload.toString()}`;

		return this.http.get<VocabularyItemList[]>(url);
	}

	// getVocabData(payload: string[], provider = 'standard'): Observable<VocabularyItemList[]> {
	// 	// const url = `${this.vocabUrl}/${provider}/${payload.toString()}`;
	// 	return this.vocabularyService.getVocabulary(provider, payload.toString());
	// }

}
